import React from 'react';

export type AnnualOperationPlanTableColGroupProps = {
  weekdayCount: number;
  classHeaderCount: number;
};

/** '클래스별 수업시수' 한 줄 헤더가 잘리지 않도록 그룹 최소 너비를 클래스 수로 나눔 */
export function resolveOperationPlanHoursColWidthPx(classHeaderCount: number): number {
  const count = Math.max(1, classHeaderCount);
  const groupLabelMinPx = 112;
  return Math.max(48, Math.ceil(groupLabelMinPx / count));
}

export const OPERATION_PLAN_COUNT_COL_WIDTH_PX = 60;

const AnnualOperationPlanTableColGroup: React.FC<AnnualOperationPlanTableColGroupProps> = ({
  weekdayCount,
  classHeaderCount,
}) => {
  const hoursColWidthPx = resolveOperationPlanHoursColWidthPx(classHeaderCount);

  return (
    <colgroup>
      <col className="cp-annual-operation-plan-col-month" />
      <col className="cp-annual-operation-plan-col-week" />
      <col
        className="cp-annual-operation-plan-col-count"
        style={{ width: `${OPERATION_PLAN_COUNT_COL_WIDTH_PX}px` }}
      />
      {Array.from({ length: weekdayCount }, (_, index) => (
        <col key={`operation-plan-day-col-${index}`} className="cp-annual-operation-plan-col-day" />
      ))}
      {Array.from({ length: Math.max(1, classHeaderCount) }, (_, index) => (
        <col
          key={`operation-plan-hours-col-${index}`}
          className="cp-annual-operation-plan-col-hours"
          style={{ width: `${hoursColWidthPx}px` }}
        />
      ))}
      <col className="cp-annual-operation-plan-col-activity" />
      <col className="cp-annual-operation-plan-col-remark" />
    </colgroup>
  );
};

export default AnnualOperationPlanTableColGroup;
